module.exports = __webpack_public_path__ + "static/media/job-post-promo-check.0bf994fa.svg";